// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1vCTn","ranges":"BmiRanges_ranges__1pd4a"};